import SlideFrame from './SlideFrame';

interface Layer { t: string; d: string }

interface Props {
  title: string; sub: string;
  layers: Layer[];
  rules_t: string;
  rules: string[];
}

export default function SecurityLayers({ title, sub, layers, rules_t, rules }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      <div className="sec-grid">
        <div className="sec-stack">
          {layers.map((layer, i) => (
            <div key={i} className="sec-layer">
              <div className="sec-layer-num">{i + 1}</div>
              <div>
                <div className="sec-layer-t">{layer.t}</div>
                <div className="sec-layer-d">{layer.d}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="sec-rules">
          <div className="sec-rules-t">{rules_t}</div>
          <ul className="sec-rules-list">
            {rules.map((rule, i) => <li key={i}>{rule}</li>)}
          </ul>
        </div>
      </div>
    </SlideFrame>
  );
}
